import { onMounted, onUnmounted, nextTick, ref, type Ref } from 'vue';

export type WindowSize = {
  windowWidth: Ref<number>;
  windowHeight: Ref<number>;
};

export function useWindow(): WindowSize {
  const windowWidth = ref(0);
  const windowHeight = ref(0);

  if (!import.meta.env.SSR) {
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;

    const updateSize = () => {
      windowWidth.value = window.innerWidth;
      windowHeight.value = window.innerHeight;
    };

    onMounted(() => {
      nextTick(() => {
        updateSize();
      });
      window.addEventListener('resize', updateSize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateSize);
    });
  }

  return { windowWidth, windowHeight };
}
